export const LOAD_BANNER = "LOAD_BANNER";
export const BANNER_OPEN = "BANNER_OPEN";
export const BANNER_CLOSE = "BANNER_CLOSE";
